/*------------------*\
     MAIN SCRIPTS
\*------------------*/

// Ready
function ready(fn) {
  document.readyState !== "loading"
    ? fn()
    : document.addEventListener("DOMContentLoaded", fn);
}

// Photos
const photos = [
  {
    id: 912,
    url: "photos/door-in-stone.webp",
    alt_text:
      "A weathered, red wooden door with a pointed arch, covered in metal studs and peeling paint, set into a wall of rough, multi-colored stone with small green plants growing from the crevices.",
    title: "Door in Stone",
    location: {
      region: "Beaumaris",
      country: "UK",
      latitude: ["53.26333", `53° 15' 47.982" N`],
      longitude: ["-4.09386", `4° 5' 37.9" W`],
    },
    device: "iPhone",
    device_model: "17",
    likes: 0,
  },
  {
    id: 439,
    url: "photos/shrooms.webp",
    alt_text:
      "A whimsical, cozy little cluster of tall mushrooms with textured, bell-shaped caps, happily growing in a misty crevice between large, mossy rocks.",
    title: "Shrooms",
    location: {
      region: "Watford",
      country: "UK",
      latitude: ["51.69112", `51° 41' 28.032" N`],
      longitude: ["-0.41856", `0° 25' 6.798" W`],
    },
    device: "iPhone",
    device_model: "17",
    likes: 0,
  },
  {
    id: 108,
    url: "photos/from-the-dafodil.webp",
    alt_text:
      "View of the Albert Dock featuring silhouettes of the historic Pumphouse chimney on the left and a tall construction crane on the right. Distinct rays of orange light radiate upward from the horizon into the deep blue sky, while the rippled water in the foreground reflects the golden glow of the sunset and dockside lights.",
    title: "From The Dafodil",
    location: {
      region: "Merseyside",
      country: "UK",
      latitude: ["53.40241", `53° 24' 8.67" N`],
      longitude: ["-2.99084", `2° 59' 27.03" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 735,
    url: "photos/blakemere-moss.webp",
    alt_text:
      "A horizontal image of a calm body of water, with a clear reflection of a bright blue sky and scattered white clouds. The shoreline is covered in green trees and bushes, and a small, grassy island sits in the middle of the water.",
    title: "Blakemere Moss",
    location: {
      region: "Delamere",
      country: "UK",
      latitude: ["53.23515", `53° 14' 6.54" N`],
      longitude: ["-2.667125", `2° 40' 1.65" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 58,
    url: "photos/casa-batllo.webp",
    alt_text:
      "A front view of Casa Batlló in Barcelona, designed by Antoni Gaudí. The facade is covered in colourful mosaic tiles, with unique bone-like balconies and wavy window frames, all under an overcast sky.",
    title: "Casa Batlló",
    location: {
      region: "Barcelona",
      country: "Spain",
      latitude: ["41.3917967", `41° 23' 30.468" N`],
      longitude: ["2.165255", `2° 9' 54.92" E`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 117,
    url: "photos/bumblebee.webp",
    alt_text:
      "A bumblebee on a cluster of small, bright yellow wildflowers with orange centers. The background is blurred green foliage and hints of blue sky.",
    title: "Bumblebee",
    location: {
      region: "Merseyside",
      country: "England",
      latitude: ["53.5643417", `53° 33' 51.63" N`],
      longitude: ["-3.092575", `3° 5' 33.27" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 237,
    url: "photos/malibu-coastline.webp",
    alt_text:
      "Pacific Ocean meeting the sandy shore, with gentle waves breaking into white foam. In the background, a hazy mountain range stretches under a heavily overcast sky, typical of a cloudy day in Malibu.",
    title: "Malibu Coastline",
    location: {
      region: "California",
      country: "United States",
      latitude: ["34.0086139", `34° 0' 31.01" N`],
      longitude: ["-118.498383", `118° 29' 54.18" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 416,
    url: "photos/south-quay.webp",
    alt_text:
      "Glass facade of South Quay Plaza, a prominent skyscraper dominating the Canary Wharf skyline under a partly cloudy sky.",
    title: "South Quay",
    location: {
      region: "London",
      country: "England",
      latitude: ["51.5018367", `51° 30' 6.612" N`],
      longitude: ["-0.01713888", `0° 1' 1.699" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 492,
    url: "photos/sacred-heart.webp",
    alt_text:
      "A low-angle shot of the stone exterior and spires, Sacred Heart Church in Omagh, Northern Ireland",
    title: "Sacred Heart",
    location: {
      region: "Tyrone",
      country: "Northern Ireland",
      latitude: ["54.60066167", `54° 36' 2.382" N`],
      longitude: ["-7.30605333", `7° 18' 21.792" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 123,
    url: "photos/contemplating-the-sea.webp",
    alt_text:
      "A woman stands on a rocky outcrop overlooking the ocean under a clear blue sky",
    title: "Contemplating the Sea",
    location: {
      region: "Merseyside",
      country: "England",
      latitude: ["51.513425", `53° 23' 1.53" N`],
      longitude: ["-0.15916389", `3° 13' 41.772" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 324,
    url: "photos/triangles.webp",
    alt_text:
      "A detailed abstract pattern of intersecting white lines forming triangles on a black background.",
    title: "Triangles",
    location: {
      region: "London",
      country: "England",
      latitude: ["53.38375833", `51° 30' 48.33" N`],
      longitude: ["-3.22827", `0° 9' 32.99" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 176,
    url: "photos/tide-pools.webp",
    alt_text:
      "A wide view of a rocky coastline with tide pools and green moss, leading to the ocean and a distant landmass under a clear sky",
    title: "Tide Pools",
    location: {
      region: "Merseyside",
      country: "England",
      latitude: ["53.38040333", `53° 22' 49.452" N`],
      longitude: ["-3.22542", `3° 13' 31.512" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 385,
    url: "photos/wilshire.webp",
    alt_text:
      "A black and white low-angle view of many vintage street lamps with decorative columns lit up against a dark night sky",
    title: "Wilshire",
    location: {
      region: "California",
      country: "United States",
      latitude: ["34.06296667", `34° 3' 46.68" N`],
      longitude: ["-118.35921333", `118° 21' 33.168" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
  {
    id: 397,
    url: "photos/patina.webp",
    alt_text:
      "A close-up of a round, copper weathered metal vent installed on a window with dark frames",
    title: "Patina",
    location: {
      region: "Merseyside",
      country: "England",
      latitude: ["53.38283833", `53° 22' 58.218" N`],
      longitude: ["-3.227895", `3° 13' 40.422" W`],
    },
    device: "iPhone",
    device_model: "14",
    likes: 0,
  },
];

// Icons
const icons = {
  like: `<svg viewBox="0 0 32 32" fill="none"><title>Like</title><path d="M31.0667 6.77327C30.4419 5.5511 29.5386 4.49285 28.4297 3.68387C27.3208 2.87489 26.0374 2.33781 24.6828 2.11594C23.3282 1.89407 21.9405 1.99362 20.6315 2.40657C19.3224 2.81951 18.1288 3.53429 17.1467 4.49327L16 5.53327L14.8934 4.51993C13.9105 3.54577 12.7096 2.81991 11.3902 2.40254C10.0709 1.98516 8.67099 1.88828 7.30669 2.11993C5.95007 2.33055 4.66358 2.86288 3.55479 3.67244C2.446 4.48199 1.54714 5.54523 0.933357 6.77327C0.107461 8.3868 -0.181441 10.222 0.10877 12.0112C0.398981 13.8004 1.25313 15.4502 2.54669 16.7199L15.04 29.5999C15.1644 29.729 15.3135 29.8316 15.4785 29.9017C15.6434 29.9718 15.8208 30.008 16 30.008C16.1792 30.008 16.3566 29.9718 16.5216 29.9017C16.6865 29.8316 16.8356 29.729 16.96 29.5999L29.44 16.7466C30.738 15.4742 31.5958 13.8205 31.8884 12.0266C32.1809 10.2327 31.8931 8.39218 31.0667 6.77327Z"></path></svg>`,
  location: `<svg viewBox="0 0 32 32" fill="none"><title>Location</title><path d="M16 0C13.2152 0 10.5445 1.12412 8.57538 3.12508C6.60625 5.12603 5.5 7.83991 5.5 10.6697C5.5 15.351 12.0625 26.6742 14.8844 31.3689C15.0021 31.5619 15.1663 31.7211 15.3616 31.8316C15.5568 31.942 15.7766 32 16 32C16.2234 32 16.4432 31.942 16.6384 31.8316C16.8337 31.7211 16.9979 31.5619 17.1156 31.3689C19.9375 26.6742 26.5 15.351 26.5 10.6697C26.5 9.26852 26.2284 7.88108 25.7007 6.58657C25.1731 5.29207 24.3996 4.11585 23.4246 3.12508C22.4496 2.13431 21.2921 1.34838 20.0182 0.812181C18.7443 0.275979 17.3789 0 16 0ZM16 15.3377C15.0914 15.3377 14.2033 15.0639 13.4478 14.551C12.6924 14.038 12.1036 13.309 11.7559 12.456C11.4082 11.6031 11.3173 10.6645 11.4945 9.759C11.6718 8.8535 12.1093 8.02175 12.7517 7.36892C13.3942 6.71609 14.2127 6.27151 15.1038 6.09139C15.9949 5.91127 16.9186 6.00372 17.758 6.35703C18.5974 6.71033 19.3148 7.30864 19.8196 8.07629C20.3243 8.84393 20.5937 9.74644 20.5937 10.6697C20.5937 11.2827 20.4749 11.8897 20.2441 12.456C20.0132 13.0224 19.6748 13.537 19.2483 13.9704C18.8217 14.4039 18.3153 14.7477 17.758 14.9823C17.2006 15.2169 16.6033 15.3377 16 15.3377Z"></path></svg>`,
  latitude: `<svg viewBox="0 0 32 32" fill="none"><title>Latitude</title><path fill-rule="evenodd" clip-rule="evenodd" d="M3.36276 12.688C4.83467 7.11252 9.93467 3 16 3C22.0654 3 27.1653 7.11252 28.6373 12.688C27.928 12.1705 27.0629 11.7164 26.0908 11.3286C23.4667 10.2816 19.8987 9.65262 16 9.65262C12.1013 9.65262 8.53323 10.2816 5.90913 11.3286C4.93716 11.7164 4.07204 12.1705 3.36276 12.688ZM3.36265 19.3115C4.8344 24.8873 9.93451 29 16 29C22.0655 29 27.1656 24.8873 28.6374 19.3115C27.9281 19.8292 27.0629 20.2833 26.0908 20.6711C23.4667 21.7181 19.8987 22.3471 16 22.3471C12.1013 22.3471 8.53323 21.7181 5.90913 20.6711C4.9371 20.2833 4.07195 19.8292 3.36265 19.3115ZM3 15.9998C3 15.5382 3.23104 15.0152 3.82728 14.4528C4.42536 13.8886 5.33536 13.3424 6.52878 12.8662C8.91107 11.9158 12.2593 11.3093 16 11.3093C19.7408 11.3093 23.0889 11.9158 25.4713 12.8662C26.6646 13.3424 27.5747 13.8886 28.1727 14.4528C28.769 15.0152 29 15.5382 29 15.9998C29 16.4614 28.769 16.9844 28.1727 17.5469C27.5747 18.1111 26.6646 18.6573 25.4713 19.1335C23.0889 20.084 19.7408 20.6904 16 20.6904C12.2593 20.6904 8.91107 20.084 6.52878 19.1335C5.33536 18.6573 4.42536 18.1111 3.82728 17.5469C3.23104 16.9844 3 16.4614 3 15.9998Z"></path></svg>`,
  longitude: `<svg viewBox="0 0 32 32" fill="none"><title>Latitude</title><path fill-rule="evenodd" clip-rule="evenodd" d="M19.312 3.36276C24.8875 4.83467 29 9.93467 29 16C29 22.0654 24.8875 27.1653 19.312 28.6373C19.8295 27.928 20.2836 27.0629 20.6714 26.0908C21.7184 23.4667 22.3474 19.8987 22.3474 16C22.3474 12.1013 21.7184 8.53323 20.6714 5.90913C20.2836 4.93716 19.8295 4.07204 19.312 3.36276ZM12.6885 3.36265C7.11266 4.8344 3 9.93451 3 16C3 22.0655 7.11266 27.1656 12.6885 28.6374C12.1708 27.9281 11.7167 27.0629 11.3289 26.0908C10.2819 23.4667 9.65291 19.8987 9.65291 16C9.65291 12.1013 10.2819 8.53323 11.3289 5.90913C11.7167 4.9371 12.1708 4.07195 12.6885 3.36265ZM16.0002 3C16.4618 3 16.9848 3.23104 17.5472 3.82728C18.1114 4.42536 18.6576 5.33536 19.1338 6.52878C20.0842 8.91107 20.6907 12.2593 20.6907 16C20.6907 19.7408 20.0842 23.0889 19.1338 25.4713C18.6576 26.6646 18.1114 27.5747 17.5472 28.1727C16.9848 28.769 16.4618 29 16.0002 29C15.5386 29 15.0156 28.769 14.4531 28.1727C13.8889 27.5747 13.3427 26.6646 12.8665 25.4713C11.916 23.0889 11.3096 19.7408 11.3096 16C11.3096 12.2593 11.9161 8.91107 12.8665 6.52878C13.3427 5.33536 13.8889 4.42536 14.4531 3.82728C15.0156 3.23104 15.5386 3 16.0002 3Z"></path></svg>`,
  device: `<svg viewBox="0 0 32 32" fill="none"><title>Device</title><path d="M3.24 14.6667H1.33333C0.979711 14.6667 0.640573 14.8071 0.390524 15.0572C0.140476 15.3072 0 15.6464 0 16C0 16.3536 0.140476 16.6928 0.390524 16.9428C0.640573 17.1929 0.979711 17.3333 1.33333 17.3333H3.24C3.59362 17.3333 3.93276 17.1929 4.18281 16.9428C4.43286 16.6928 4.57333 16.3536 4.57333 16C4.57333 15.6464 4.43286 15.3072 4.18281 15.0572C3.93276 14.8071 3.59362 14.6667 3.24 14.6667Z"></path><path d="M3.24 21.3333H1.33333C0.979711 21.3333 0.640573 21.4738 0.390524 21.7239C0.140476 21.9739 0 22.313 0 22.6667C0 23.0203 0.140476 23.3594 0.390524 23.6095C0.640573 23.8595 0.979711 24 1.33333 24H3.24C3.59362 24 3.93276 23.8595 4.18281 23.6095C4.43286 23.3594 4.57333 23.0203 4.57333 22.6667C4.57333 22.313 4.43286 21.9739 4.18281 21.7239C3.93276 21.4738 3.59362 21.3333 3.24 21.3333Z"></path><path d="M3.24 8.66667H1.33333C0.979711 8.66667 0.640573 8.80714 0.390524 9.05719C0.140476 9.30724 0 9.64638 0 10C0 10.3536 0.140476 10.6928 0.390524 10.9428C0.640573 11.1929 0.979711 11.3333 1.33333 11.3333H3.24C3.59362 11.3333 3.93276 11.1929 4.18281 10.9428C4.43286 10.6928 4.57333 10.3536 4.57333 10C4.57333 9.64638 4.43286 9.30724 4.18281 9.05719C3.93276 8.80714 3.59362 8.66667 3.24 8.66667Z"></path><path d="M30.6667 14.6667H28.76C28.4064 14.6667 28.0672 14.8071 27.8172 15.0572C27.5671 15.3072 27.4267 15.6464 27.4267 16C27.4267 16.3536 27.5671 16.6928 27.8172 16.9428C28.0672 17.1929 28.4064 17.3333 28.76 17.3333H30.6667C31.0203 17.3333 31.3594 17.1929 31.6095 16.9428C31.8595 16.6928 32 16.3536 32 16C32 15.6464 31.8595 15.3072 31.6095 15.0572C31.3594 14.8071 31.0203 14.6667 30.6667 14.6667Z"></path><path d="M28.76 11.3333H30.6667C31.0203 11.3333 31.3594 11.1929 31.6095 10.9428C31.8595 10.6928 32 10.3536 32 10C32 9.64638 31.8595 9.30724 31.6095 9.05719C31.3594 8.80714 31.0203 8.66667 30.6667 8.66667H28.76C28.4064 8.66667 28.0672 8.80714 27.8172 9.05719C27.5671 9.30724 27.4267 9.64638 27.4267 10C27.4267 10.3536 27.5671 10.6928 27.8172 10.9428C28.0672 11.1929 28.4064 11.3333 28.76 11.3333Z"></path><path d="M30.6667 21.3333H28.76C28.4064 21.3333 28.0672 21.4738 27.8172 21.7239C27.5671 21.9739 27.4267 22.313 27.4267 22.6667C27.4267 23.0203 27.5671 23.3594 27.8172 23.6095C28.0672 23.8595 28.4064 24 28.76 24H30.6667C31.0203 24 31.3594 23.8595 31.6095 23.6095C31.8595 23.3594 32 23.0203 32 22.6667C32 22.313 31.8595 21.9739 31.6095 21.7239C31.3594 21.4738 31.0203 21.3333 30.6667 21.3333Z"></path><path d="M16 4.58667C16.3536 4.58667 16.6928 4.44619 16.9428 4.19614C17.1929 3.94609 17.3333 3.60696 17.3333 3.25333V1.33333C17.3333 0.979711 17.1929 0.640573 16.9428 0.390524C16.6928 0.140476 16.3536 0 16 0C15.6464 0 15.3072 0.140476 15.0572 0.390524C14.8071 0.640573 14.6667 0.979711 14.6667 1.33333V3.25333C14.6667 3.60696 14.8071 3.94609 15.0572 4.19614C15.3072 4.44619 15.6464 4.58667 16 4.58667Z"></path><path d="M10 4.58667C10.3536 4.58667 10.6928 4.44619 10.9428 4.19614C11.1929 3.94609 11.3333 3.60696 11.3333 3.25333V1.33333C11.3333 0.979711 11.1929 0.640573 10.9428 0.390524C10.6928 0.140476 10.3536 3.97367e-08 10 3.97367e-08C9.64638 3.97367e-08 9.30724 0.140476 9.05719 0.390524C8.80714 0.640573 8.66667 0.979711 8.66667 1.33333V3.25333C8.66667 3.60696 8.80714 3.94609 9.05719 4.19614C9.30724 4.44619 9.64638 4.58667 10 4.58667Z"></path><path d="M22 4.58667C22.3536 4.58667 22.6928 4.44619 22.9428 4.19614C23.1929 3.94609 23.3333 3.60696 23.3333 3.25333V1.33333C23.3333 0.979711 23.1929 0.640573 22.9428 0.390524C22.6928 0.140476 22.3536 0 22 0C21.6464 0 21.3072 0.140476 21.0572 0.390524C20.8071 0.640573 20.6667 0.979711 20.6667 1.33333V3.25333C20.6667 3.60696 20.8071 3.94609 21.0572 4.19614C21.3072 4.44619 21.6464 4.58667 22 4.58667Z"></path><path d="M16 27.4267C15.6464 27.4267 15.3072 27.5671 15.0572 27.8172C14.8071 28.0672 14.6667 28.4064 14.6667 28.76V30.6667C14.6667 31.0203 14.8071 31.3594 15.0572 31.6095C15.3072 31.8595 15.6464 32 16 32C16.3536 32 16.6928 31.8595 16.9428 31.6095C17.1929 31.3594 17.3333 31.0203 17.3333 30.6667V28.76C17.3333 28.5849 17.2988 28.4115 17.2318 28.2498C17.1648 28.088 17.0666 27.941 16.9428 27.8172C16.819 27.6934 16.672 27.5952 16.5102 27.5282C16.3485 27.4612 16.1751 27.4267 16 27.4267Z"></path><path d="M22 27.4267C21.6464 27.4267 21.3072 27.5671 21.0572 27.8172C20.8071 28.0672 20.6667 28.4064 20.6667 28.76V30.6667C20.6667 31.0203 20.8071 31.3594 21.0572 31.6095C21.3072 31.8595 21.6464 32 22 32C22.3536 32 22.6928 31.8595 22.9428 31.6095C23.1929 31.3594 23.3333 31.0203 23.3333 30.6667V28.76C23.3333 28.4064 23.1929 28.0672 22.9428 27.8172C22.6928 27.5671 22.3536 27.4267 22 27.4267Z"></path><path d="M10 27.4267C9.64638 27.4267 9.30724 27.5671 9.05719 27.8172C8.80714 28.0672 8.66667 28.4064 8.66667 28.76V30.6667C8.66667 31.0203 8.80714 31.3594 9.05719 31.6095C9.30724 31.8595 9.64638 32 10 32C10.3536 32 10.6928 31.8595 10.9428 31.6095C11.1929 31.3594 11.3333 31.0203 11.3333 30.6667V28.76C11.3333 28.5849 11.2988 28.4115 11.2318 28.2498C11.1648 28.088 11.0666 27.941 10.9428 27.8172C10.819 27.6934 10.672 27.5952 10.5102 27.5282C10.3485 27.4612 10.1751 27.4267 10 27.4267Z"></path><path d="M24.0933 6H7.90667C7.40099 6 6.91602 6.20088 6.55845 6.55845C6.20088 6.91602 6 7.40099 6 7.90667V24.0933C6 24.599 6.20088 25.084 6.55845 25.4416C6.91602 25.7991 7.40099 26 7.90667 26H24.0933C24.599 26 25.084 25.7991 25.4416 25.4416C25.7991 25.084 26 24.599 26 24.0933V7.90667C26 7.40099 25.7991 6.91602 25.4416 6.55845C25.084 6.20088 24.599 6 24.0933 6ZM22 20.6667C22 21.0203 21.8595 21.3594 21.6095 21.6095C21.3594 21.8595 21.0203 22 20.6667 22H17.3333C16.9797 22 16.6406 21.8595 16.3905 21.6095C16.1405 21.3594 16 21.0203 16 20.6667C16 20.313 16.1405 19.9739 16.3905 19.7239C16.6406 19.4738 16.9797 19.3333 17.3333 19.3333H20.6667C21.0203 19.3333 21.3594 19.4738 21.6095 19.7239C21.8595 19.9739 22 20.313 22 20.6667Z"></path></svg>`,
};

// Like Photo Event Handler
async function likePhotoHandler(event) {
  event.preventDefault();
  let likeBtn = event.currentTarget;
  likeBtn.disabled = true;

  // Request -->
  // console.log(`Photo ${likeBtn.dataset.photoId} liked`);
  let response = { id: "000", likes: 1 };
  const countSpan = likeBtn.querySelector(".count");
  countSpan.innerText = response.likes;

  likeBtn.classList.toggle("liked");
  likeBtn.disabled = false;
}

// Create Photo
function createPhotoElement(data) {
  const photo = document.createElement("div");
  photo.classList.add("photo");

  // Image
  const photoImage = document.createElement("div");
  photoImage.classList.add("photo-image");
  // Image element
  const photoImg = document.createElement("img");
  photoImg.src = data.url;
  photoImg.alt = data.alt_text;

  // Detail
  const photoDetail = document.createElement("div");
  photoDetail.classList.add("photo-detail");

  // Header
  const photoHeader = document.createElement("header");
  photoHeader.classList.add("photo-header");
  // Title
  const photoTitle = document.createElement("h2");
  photoTitle.classList.add("photo-title");
  const photoTitleText = document.createTextNode(data.title);
  photoTitle.appendChild(photoTitleText);

  // Actions
  const photoActions = document.createElement("div");
  photoActions.classList.add("photo-actions");
  const photoLike = document.createElement("button");
  photoLike.classList.add("like");
  photoLike.dataset.photoId = data.id;
  photoLike.addEventListener("click", likePhotoHandler);
  const photoLikeSVG = icons.like;
  const photoLikeValue = document.createElement("span");
  photoLikeValue.classList.add("count");
  const photoLikeCount = document.createTextNode(data.likes);
  photoLikeValue.appendChild(photoLikeCount);
  photoLike.innerHTML = photoLikeSVG;
  photoLike.appendChild(photoLikeValue);

  // Content
  const photoContent = document.createElement("div");
  photoContent.classList.add("photo-content");

  // Location
  const photoLocation = document.createElement("div");
  photoLocation.classList.add("photo-location");
  const photoLocationIcon = document.createElement("span");
  photoLocationIcon.classList.add("icon");
  const photoLocationIconSVG = icons.location;
  const photoLocationText = document.createTextNode(
    `${data.location.region}, ${data.location.country}`,
  );
  photoLocationIcon.innerHTML = photoLocationIconSVG;
  photoLocation.appendChild(photoLocationIcon);
  photoLocation.appendChild(photoLocationText);

  // Location Data
  const photoLocationData = document.createElement("div");
  photoLocationData.classList.add("photo-location-data");

  const photoLatitude = document.createElement("div");
  photoLatitude.classList.add("latitude");
  const photoLatitudeIcon = document.createElement("span");
  photoLatitudeIcon.classList.add("icon");
  const photoLatitudeIconSVG = icons.latitude;
  photoLatitudeIcon.innerHTML = photoLatitudeIconSVG;
  const photoLatitudeText = document.createTextNode(data.location.latitude[1]);
  photoLatitude.appendChild(photoLatitudeIcon);
  photoLatitude.appendChild(photoLatitudeText);

  const photoLongitude = document.createElement("div");
  photoLongitude.classList.add("longitude");
  const photoLongitudeIcon = document.createElement("span");
  photoLongitudeIcon.classList.add("icon");
  const photoLongitudeIconSVG = icons.longitude;
  photoLongitudeIcon.innerHTML = photoLongitudeIconSVG;
  const photoLongitudeText = document.createTextNode(
    data.location.longitude[1],
  );
  photoLongitude.appendChild(photoLongitudeIcon);
  photoLongitude.appendChild(photoLongitudeText);

  photoLocationData.appendChild(photoLatitude);
  photoLocationData.appendChild(photoLongitude);

  // Data
  const photoData = document.createElement("div");
  photoData.classList.add("photo-data");
  const photoDevice = document.createElement("div");
  photoDevice.classList.add("device");
  const photoDeviceIcon = document.createElement("span");
  photoDeviceIcon.classList.add("icon");
  const photoDeviceIconSVG = icons.device;
  photoDeviceIcon.innerHTML = photoDeviceIconSVG;
  const photoDeviceText = document.createTextNode(
    `${data.device} ${data.device_model}`,
  );
  photoDevice.appendChild(photoDeviceIcon);
  photoDevice.appendChild(photoDeviceText);
  photoData.appendChild(photoDevice);

  // Build Content
  photoContent.appendChild(photoLocation);
  photoContent.appendChild(photoLocationData);
  photoContent.appendChild(photoData);
  // Build Actions
  photoActions.appendChild(photoLike);
  // Build Header
  photoHeader.appendChild(photoTitle);
  // photoHeader.appendChild(photoActions);
  // Build Detail
  photoDetail.appendChild(photoHeader);
  photoDetail.appendChild(photoContent);
  // Build Image
  photoImage.appendChild(photoImg);
  // Build the Photo element
  photo.appendChild(photoImage);
  photo.appendChild(photoDetail);
  return photo;
}

// Init
const init = async () => {
  // Ready
  // console.log("Ready!");

  // Build Photo Feed
  const feed = document.querySelector(".photo-feed");
  if (feed && photos && photos.length >= 1) {
    photos.forEach(function (photo) {
      const photoElement = createPhotoElement(photo);
      feed.appendChild(photoElement);
    });
  }
};

// Initialise on Document Ready
ready(init);
